"use strict";

exports.__esModule = true;
exports.default = exports.DragAndDrop = exports.Basic = void 0;

var _styledComponents = require("styled-components");

var _styles = require("../styles");

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n    background: rgba(255,255,255,.8);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n    height: 100%;\n    width: 100%;\n\n    video {\n      width: 100%;\n      height: 100%;\n    }\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 24px;\n    height: 24px;\n    opacity: 0.7;\n    display: flex;\n    background: #657480;\n    background: ", ";\n    align-items: center;\n    border-radius: 50%;\n    justify-content: center;\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    z-index: 3;\n    cursor: pointer;\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n    ", " {\n      max-height: 147px;\n      max-width: 240px;\n    }\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n\n    ", " {\n      margin: 0;\n      border: 1px solid #ACC2D3;\n      border-radius: 4px;\n      height: 147px;\n      width: 240px;\n      padding: 12px;\n      border: 1px ", " solid;\n      border-radius: 4px;\n    }\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 12px;\n    color: ", ";\n    letter-spacing: -0.43px;\n    line-height: 18px;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 12px;\n    color: ", ";\n    letter-spacing: -0.5px;\n    line-height: 16px;\n    margin-bottom: 5px;\n    margin-right: 5px;\n\n    ", " {\n      margin-top: 10px;\n      margin-right: 0px;\n    }\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 5px;\n\n    ", " {\n      flex-direction: column;\n    }\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n\n    ", " {\n      flex-direction: row;\n    }\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    font-size: 12px;\n    color: ", ";\n    letter-spacing: -0.5px;\n    text-align: center;\n    line-height: 16px;\n    font-weight: 400;\n    margin-bottom: 20px;\n    \n    ", " {\n      margin-bottom: 0;\n    }\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    border: 2px solid ", ";\n    border-radius: 4px;\n    border-style: dashed;\n    min-height: 170px;\n    background: #ffffff;\n    padding: 10px 10px 0 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    cursor: pointer;\n    z-index: 1;\n    position: relative;\n    \n    ", " {\n       max-height: 170px;\n       overflow: scroll;\n       padding: 10px 10px 15px 15px;\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n\n    .Filer-facade {\n      .row-item-upload {\n        &:not(:last-child){\n          margin-bottom: 10px;\n        }\n      }\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 24px;\n    height: 24px;\n    opacity: 0.7;\n    display: flex;\n    background: #657480;\n    background: ", ";\n    align-items: center;\n    border-radius: 50%;\n    justify-content: center;\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    z-index: 3;\n    cursor: pointer;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    right: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    z-index: 1;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    font-size: 14px;\n    margin: 0 10px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 40px;\n    background: white;\n    border-radius: 100px;\n    border: 1px solid ", ";\n    padding: 0 20px;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n\n    &:after {\n      content: '';\n      position: absolute;\n      right: 0;\n      width: 40px;\n      height: 40px;\n      border-radius: 100px;\n      background-color: ", "\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    position: relative;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var KineduPalette = _styles.colorPalettes.KineduPalette;
var Basic = {
  wrapper: (0, _styledComponents.css)(_templateObject()),
  facade: (0, _styledComponents.css)(_templateObject2(), KineduPalette.shadeMediumLight, KineduPalette.excel),
  file: (0, _styledComponents.css)(_templateObject3(), KineduPalette.shadeMediumLight),
  icon: (0, _styledComponents.css)(_templateObject4()),
  quitIcon: (0, _styledComponents.css)(_templateObject5(), KineduPalette.shadeDark)
};
exports.Basic = Basic;
var DragAndDrop = {
  wrapper: (0, _styledComponents.css)(_templateObject6()),
  facade: (0, _styledComponents.css)(_templateObject7(), KineduPalette.shadeMedium, _styles.breakPoints.tablet),
  recomendation: (0, _styledComponents.css)(_templateObject8(), KineduPalette.shadeMediumDark, _styles.breakPoints.tablet),
  icon: (0, _styledComponents.css)(_templateObject9()),
  rowItem: (0, _styledComponents.css)(_templateObject10(), _styles.breakPoints.desktop),
  colInfo: (0, _styledComponents.css)(_templateObject11(), _styles.breakPoints.desktop),
  infoLabel: (0, _styledComponents.css)(_templateObject12(), KineduPalette.shadeMediumDark, _styles.breakPoints.desktop),
  infoName: (0, _styledComponents.css)(_templateObject13(), KineduPalette.shadeDark),
  previewUpload: (0, _styledComponents.css)(_templateObject14(), _styles.breakPoints.tablet, KineduPalette.shadeMedium),
  imagePreview: (0, _styledComponents.css)(_templateObject15(), _styles.breakPoints.tablet),
  quitIcon: (0, _styledComponents.css)(_templateObject16(), KineduPalette.shadeDark),
  videoWrapper: (0, _styledComponents.css)(_templateObject17()),
  draggingOverlay: (0, _styledComponents.css)(_templateObject18())
};
exports.DragAndDrop = DragAndDrop;
var _default = {
  Basic: Basic,
  DragAndDrop: DragAndDrop
};
exports.default = _default;